import { InstructionFeedbackActivityProduct } from "@/models/instruction-feedback-activity-product"
import type { IInstructionFeedbackActivityProduct } from "@/interfaces/api/instruction-feedback-activity-product.interface"
import { InstructionFeedbackActivityProductRepository } from "@/repositories/instruction-feedback-activity-product-repository"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { useInstructionFeedbacksActivitiesProductsStore } from "@/store/instruction-feedbacks-activities-products.store"
import type { InstructionFeedbackActivity } from "@/models/instruction-feedback-activity.model"
import type { IRepositoryRequestConfig } from "@/interfaces/repository/repository-request-config.interface"

export class InstructionFeedbackActivityProductController extends GenericModelController<
  InstructionFeedbackActivityProduct,
  IInstructionFeedbackActivityProduct,
  InstructionFeedbackActivityProductRepository
> {
  constructor() {
    const instructionFeedbacksActivitiesProductsStore =
      useInstructionFeedbacksActivitiesProductsStore()
    const {
      pushToRelatedAppInstructions,
      removeFromRelatedAppInstructions,
      pushToRelatedPlanningInstructions,
      removeFromRelatedPlanningInstructions
    } = instructionFeedbacksActivitiesProductsStore
    const storeFunctionsConfig = {
      onCreate: (instructionFeedbackActivityProduct: InstructionFeedbackActivityProduct) => {
        pushToRelatedAppInstructions(instructionFeedbackActivityProduct)
        pushToRelatedPlanningInstructions(instructionFeedbackActivityProduct)
      },
      onDelete: (instructionFeedbackActivityProduct: InstructionFeedbackActivityProduct) => {
        removeFromRelatedAppInstructions(instructionFeedbackActivityProduct)
        removeFromRelatedPlanningInstructions(instructionFeedbackActivityProduct)
      }
    }

    super(
      InstructionFeedbackActivityProduct,
      storeFunctionsConfig,
      new InstructionFeedbackActivityProductRepository()
    )
    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      InstructionFeedbackActivityProduct,
      null,
      pushToRelatedPlanningInstructions,
      removeFromRelatedPlanningInstructions,
      false
    )
  }

  public async createProductForInstructionFeedbackActivity(
    instructionFeedbackActivity: InstructionFeedbackActivity,
    instructionFeedbackActivityProduct: InstructionFeedbackActivityProduct,
    requestConfig?: IRepositoryRequestConfig
  ) {
    instructionFeedbackActivityProduct.instructionFeedbackActivity = instructionFeedbackActivity.id!
    return this.create(instructionFeedbackActivityProduct, requestConfig)
  }
}
